import React from "react";
import { useSelector } from "react-redux";

export const usePlanInfo = () => {
  const {
    isTrial,
    isSubscribed,
    isAdmin,
    isOnTtsPlan,
    user: {
      data: {
        stripe: { trial_used },
      },
    },
    credits: { initialCredits, creditsUsed },
  } = useSelector((store) => store.auth);
  const { activePriceId } = useSelector((store) => store.stripe);

  const isTrialExpired = !isTrial && trial_used && !isSubscribed;

  const isPerCredits =
    !isAdmin &&
    !isTrial &&
    !isSubscribed &&
    (initialCredits !== 0 || initialCredits - creditsUsed !== 0);

  const isSubscribedToPaidPlan =
    isSubscribed &&
    activePriceId &&
    !isTrial &&
    !isTrialExpired &&
    !isPerCredits;

  const isTtsOnly = isOnTtsPlan && initialCredits === 0;

  return {
    isSubscribedToPaidPlan,
    isTrialExpired,
    isPerCredits,
    isTtsOnly,
  };
};
